























import Vue from 'vue';
import { CandidateStudyProgram } from '~/services/CSPService';

// Components
import StudyProgramForm from './StudyProgramForm.vue';

export default Vue.extend({
    name: 'StudyProgramFormDialog',
    components: {
        StudyProgramForm,
    },
    props: {
        candidateStudyProgram: {
            type: Object as () => CandidateStudyProgram,
            required: false,
            default: undefined,
        },
    },
    computed: {
        isExisting() {
            return Boolean(this.candidateStudyProgram && this.candidateStudyProgram.id);
        },
    },
});
